module.exports = __webpack_public_path__ + "img/logo-kernhigh.e9819987.png";